const pageNameKey = "initialStructureFilter";

export const initialStructureFilterEn = {
  [pageNameKey]: {
    subtitle: "Initial Structure Filter",
    labelText: "Filter for names and ids",
    textAreaPlaceholder: "e.g. Temperature",
    showResults: "Show Results",
    clearFilter: "Clear Filter",
  },
};

export const initialStructureFilterPtBr = {
  [pageNameKey]: {
    subtitle: "Filtro de Estrutura Inicial",
    labelText: "Filtrar por nomes e IDs",
    textAreaPlaceholder: "por exemplo, Temperatura",
    showResults: "Mostrar resultados",
    clearFilter: "Limpar filtro",
  },
};

export const initialStructureFilterDe = {
  [pageNameKey]: {
    subtitle: "Initiale Strukturfilter",
    labelText: "Filter nach Namen und IDs",
    textAreaPlaceholder: "z.B.: Temperatur",
    showResults: "Ergebnisse anzeigen",
    clearFilter: "Filter zurücksetzen",
  },
};

export const initialStructureFilterZhHans = {
  [pageNameKey]: {
    subtitle: "初始结构过滤器",
    labelText: "按名称和ID过滤",
    textAreaPlaceholder: "例如：温度",
    showResults: "显示结果",
    clearFilter: "清除过滤器",
  },
};

export const initialStructureFilterIt = {
  [pageNameKey]: {
    subtitle: "Filtro struttura iniziale",
    labelText: "Filtra per nomi e ID",
    textAreaPlaceholder: "es. Temperatura",
    showResults: "Mostra i risultati",
    clearFilter: "Rimuovi filtro",
  },
};

export const initialStructureFilterEs = {
  [pageNameKey]: {
    subtitle: "Filtro de estructura inicial",
    labelText: "Filtrar por nombres e id",
    textAreaPlaceholder: "p. ej., Temperatura",
    showResults: "Mostrar resultados",
    clearFilter: "Borrar filtro",
  },
};

export const initialStructureFilterNl = {
  [pageNameKey]: {
    clearFilter: "Filter resetten",
    labelText: "Filteren op namen en ID's",
    showResults: "Resultaten weergeven",
    subtitle: "Initiële structuurfilters",
    textAreaPlaceholder: "bijv. Temperatuur",
  },
};

export const initialStructureFilterTr = {
  [pageNameKey]: {
    clearFilter: "Filtreyi Temizle",
    labelText: "Adlar ve kimlikler için filtreleyin",
    showResults: "Sonuçları Göster",
    subtitle: "İlk Yapı Filtresi",
    textAreaPlaceholder: "örneğin Sıcaklık",
  },
};
